import Nav  from './nav/nav';
import Body from './body/body';

const Layout = (props: any) => {
  return (
    <div className="ct-pt-10">
      { props.children }
    </div>
  )
}

Layout.Nav = Nav;
Layout.Body = Body

export default Layout;